import {
  mapECCustomerFolderSummariesToFolderList,
  mapECFolderSummariesToFolderList,
  mapECHrFolderSummariesToFolderList,
  mapECValidatedFolderSummariesToFolderList,
} from "src/brand/EC/mappers/folder.mapper";
import { FolderListStrategyEC } from "src/brand/EC/strategies/FolderList.strategy";
import { BrandConfig } from "src/brand/schema";
import Completion from "src/core/assets/images/icons/completion.svg?react";
import Renewal from "src/core/assets/images/icons/renewal.svg?react";
import ShieldDanger from "src/core/assets/images/icons/shieldDanger.svg?react";
import ShieldOk from "src/core/assets/images/icons/shieldOk.svg?react";
import Validated from "src/core/assets/images/icons/validated.svg?react";
import Logo from "src/core/assets/images/logo.svg?react";
import { BRANDS } from "src/core/constants/brand";
import { CustomFolderFileType, Status } from "src/core/constants/folders";
import { Roles } from "src/core/constants/roles";
import { ROUTE_PATH } from "src/core/constants/routePath";
import {
  CustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotQuery,
  FolderFilesPageHrQuery,
  FolderFilesPageQuery,
  LastModifiedFolderFilePerCurrentCustomerFolderQuery,
} from "src/core/gql/graphql";
import { FoldersConfig } from "src/core/types/folders";

const foldersConfig: FoldersConfig[] = [
  {
    icon: ShieldDanger,
    titleKey: "home.riskFolders",
    subtitleKey: "home.riskFoldersSubtitle",
    listKey: "home.riskFolders",
    variant: "violet",
    requiredGroups: [Roles.ADMINISTRATEUR, Roles.ASSOCIE, Roles.AUDITEUR],
    status: Status.VALIDATION_PENDING_HR,
    noResultText: "folders.list.noResultRisk",
  },
  {
    icon: ShieldOk,
    titleKey: "home.validationFolders",
    subtitleKey: "home.validationFoldersSubtitle",
    listKey: "home.validationFolders",
    variant: "red",
    requiredGroups: [Roles.ADMINISTRATEUR, Roles.ASSOCIE, Roles.EXPERT_COMPTABLE, Roles.AUDITEUR],
    status: Status.VALIDATION_PENDING,
    noResultText: "folders.list.noResultValid",
  },
  {
    icon: Completion,
    titleKey: "home.completedFolders",
    subtitleKey: "home.validationFoldersSubtitle",
    listKey: "home.completedFolders",
    variant: "blue",
    requiredGroups: [
      Roles.ADMINISTRATEUR,
      Roles.ASSOCIE,
      Roles.EXPERT_COMPTABLE,
      Roles.COLLABORATEUR,
      Roles.AUDITEUR,
    ],
    status: Status.DRAFT,
    folderFileType: CustomFolderFileType.MISSION_CREATION,
    noResultText: "folders.list.noResult",
  },
  {
    icon: Renewal,
    titleKey: "home.renewalFolders",
    subtitleKey: "home.renewalFoldersSubtitle",
    listKey: "home.renewalFoldersList",
    variant: "orange",
    requiredGroups: [
      Roles.ADMINISTRATEUR,
      Roles.ASSOCIE,
      Roles.EXPERT_COMPTABLE,
      Roles.COLLABORATEUR,
      Roles.AUDITEUR,
    ],
    status: Status.RENEWAL,
    folderFileType: CustomFolderFileType.MISSION_RENEWAL,
  },
  {
    icon: Validated,
    titleKey: "home.treatsFolders",
    subtitleKey: "home.treatsFoldersSubtitle",
    listKey: "home.treatsFoldersList",
    variant: "green",
    requiredGroups: [
      Roles.ADMINISTRATEUR,
      Roles.ASSOCIE,
      Roles.EXPERT_COMPTABLE,
      Roles.COLLABORATEUR,
      Roles.AUDITEUR,
    ],
    status: Status.VALIDATED,
  },
];

const strategies = {
  folder: {
    list: FolderListStrategyEC,
    data: {
      sourceByStatus: (status: Status) => {
        switch (status) {
          case Status.VALIDATION_PENDING_HR:
            return "EC.listHr";
          case Status.RENEWAL:
            return "EC.listRenewal";
          case Status.VALIDATED:
            return "EC.listValidated";
          default:
            return "EC.list";
        }
      },
      mapRawToRows: (status: Status, raw: unknown[]) => {
        switch (status) {
          case Status.VALIDATION_PENDING_HR:
            return mapECHrFolderSummariesToFolderList(
              raw as FolderFilesPageHrQuery["folderFilesPage"]["summaries"]
            );
          case Status.RENEWAL:
            return mapECCustomerFolderSummariesToFolderList(
              raw as CustomerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshotQuery["customerFoldersHavingAtLeastOneInactiveMissionInLatestSnapshot"]["summaries"]
            );
          case Status.VALIDATED:
            return mapECValidatedFolderSummariesToFolderList(
              raw as LastModifiedFolderFilePerCurrentCustomerFolderQuery["lastModifiedFolderFilePerCurrentCustomerFolder"]["content"]
            );
          default:
            return mapECFolderSummariesToFolderList(
              raw as FolderFilesPageQuery["folderFilesPage"]["summaries"]
            );
        }
      },
    },
  },
};

export const configEC: BrandConfig<"EC"> = {
  id: BRANDS.EC,
  brand: "EC",
  title: "EC",
  logo: Logo,
  foldersConfig: foldersConfig,
  strategies,
  createFolderFile: true,
  redirectionAfterCreation: ROUTE_PATH.FOLDER,
};
